export default (error) =>
  error &&
  error.graphQLErrors &&
  error.graphQLErrors.length > 0 &&
  error.graphQLErrors[0]?.extensions?.response?.status;
